import * as React from "react";
const SvgGrid2X1 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,22h20v20h-20z m28,0h20v20h-20z" }));
export default SvgGrid2X1;
